/* eslint-disable func-names */
/* eslint-disable max-len */
/* eslint-disable no-return-assign */

/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useState } from 'react';
import { Field, reduxForm } from 'redux-form';
import {
  Card, CardBody, Col, ButtonToolbar, Button, Progress,
} from 'reactstrap';
import { RiErrorWarningLine } from 'react-icons/ri';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Editor } from '@tinymce/tinymce-react';
import { message } from 'antd';
import renderFileInputField from '../../../../../shared/components/form/FileInput';
import { LOCALSTORAGE_TOKEN, LOCALSTORAGE_USERDETAIL } from '../../../../../utils/Types';
import { URL_MATERIAL } from '../../../../../utils/EndPoints';

const CreateMaterialForm = () => {
  const { id } = useParams();
  const editorRef = useRef(null);
  const [progress, setProgress] = useState(null);

  // loading
  const [loading, setLoading] = useState(false);

  // Tinymce Editor
  const [content, setContents] = useState('');
  const handleEditorChange = (contents) => {
    setContents(contents);
  };

  // alert
  const [alertModul, setAlertModul] = useState(false);
  const [alertVideo, setAlertVideo] = useState(false);
  const [alertTranscript, setAlertFileTranscript] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    const userDetail = JSON.parse(localStorage.getItem(LOCALSTORAGE_USERDETAIL));
    const dataMaterial = new FormData();
    dataMaterial.append('userId', userDetail.id);
    dataMaterial.append('name', e.target.name.value);
    dataMaterial.append('order', e.target.order.value);
    if (e.target.modul.files[0] !== undefined) {
      dataMaterial.append('modul', e.target.modul.files[0]);
    }
    if (e.target.video.files[0] !== undefined) {
      dataMaterial.append('video', e.target.video.files[0]);
    }
    dataMaterial.append('topicId', id);
    if (e.target.file_transcript.files[0] !== undefined) {
      dataMaterial.append('file_transcript', e.target.file_transcript.files[0]);
    }
    dataMaterial.append('transcript', content);
    const token = localStorage.getItem(LOCALSTORAGE_TOKEN);
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Token ${token}`,
      },
      onUploadProgress: (data) => {
        setProgress(Math.round((100 * data.loaded) / data.total));
      },
    };
    setLoading(true);
    axios.post(URL_MATERIAL, dataMaterial, options)
      .then(() => {
        window.location.reload();
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        message.error('Something went wrong!');
      });
  };

  return (
    <Col md={12} lg={12}>
      <Card className="card--not-full-height">
        <CardBody className="dashboard__booking-card">
          <form className="form" onSubmit={onSubmit}>
            <span className="form__form-group-label">Order Material</span>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  name="order"
                  component="input"
                  type="number"
                  placeholder="Order Material"
                  min="1"
                  required
                />
              </div>
            </div>
            <span className="form__form-group-label">Title Material</span>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  name="name"
                  component="input"
                  type="text"
                  placeholder="Title Material"
                  required
                />
              </div>
            </div>
            <span className="form__form-group-label">Modul</span>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  name="modul"
                  component={renderFileInputField}
                  type="file"
                  // accept="application/pdf"
                  required
                  onChange={(e) => {
                    if ((e.file.type.includes('application/vnd.openxmlformats-officedocument.presentationml.presentation')) || (e.file.type.includes('application/pdf') || (e.file.type.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document')))) {
                      setAlertModul(false);
                    } else {
                      setAlertModul(true);
                    }
                  }}
                />
              </div>
              {alertModul && (
                <span style={{ color: 'red' }}><RiErrorWarningLine /> Please setup file pdf / word / ppt</span>
              )}
            </div>
            <span className="form__form-group-label">Video</span>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  name="video"
                  component={renderFileInputField}
                  type="file"
                  onChange={(e) => {
                    if (!e.file.type.includes('video')) {
                      setAlertVideo(true);
                    } else {
                      setAlertVideo(false);
                    }
                  }}
                />
              </div>
              {alertVideo && (
              <span style={{ color: 'red' }}><RiErrorWarningLine /> Please upload video with .mp4 type file</span>
              )}
            </div>
            <span className="form__form-group-label">Transcript Video</span>
            <div className="form__form-group">
              <div className="form__form-group-field w-100-role-application">
                <input
                  id="my-file"
                  type="file"
                  name="my-file"
                  style={{ display: 'none' }}
                />
                <Editor
                  onInit={(evt, editor) => (editorRef.current = editor)}
                  apiKey="kdsr6jcmxjffjg6z20pb4vtbg0fegwqdqy6ltsxoahuo3dvg"
                  init={{
                    skin: 'snow',
                    icons: 'thin',
                    height: 500,
                    menubar: true,
                    plugins: [
                      'advlist autolink lists link image charmap print preview anchor',
                      'searchreplace visualblocks code fullscreen textcolor ',
                      'insertdatetime media table paste code help wordcount',
                      'image code',
                    ],
                    image_title: true,
                    automatic_uploads: true,
                    file_picker_types: 'image',
                    textcolor_rows: '4',
                    file_picker_callback(callback, value, meta) {
                      if (meta.filetype === 'image') {
                        const input = document.getElementById('my-file');
                        input.click();
                        input.onchange = function () {
                          const file = input.files[0];
                          const reader = new FileReader();
                          reader.onload = function (e) {
                            callback(e.target.result, {
                              alt: file.name,
                            });
                          };
                          reader.readAsDataURL(file);
                        };
                      }
                    },

                    content_style:
                      "@import url('http://fonts.gstatic.com/s/nunito/v7/1TiHc9yag0wq3lDO9cw0vpBw1xU1rKptJj_0jans920.woff2');",
                    font_formats: 'Nunito',

                    toolbar:
                      'undo redo | styleselect | fontselect | fontsizeselect| code | bold italic | alignleft aligncenter alignright alignjustify | outdent indent ',
                  }}
                  onEditorChange={handleEditorChange}
                  outputFormat="html"
                />
              </div>
            </div>
            <span className="form__form-group-label">File Transcript</span>
            <div className="form__form-group">
              <div className="form__form-group-field">
                <Field
                  name="file_transcript"
                  component={renderFileInputField}
                  type="file"
                  onChange={(e) => {
                    if ((e.file.type.includes('application/vnd.openxmlformats-officedocument.presentationml.presentation')) || (e.file.type.includes('application/pdf') || (e.file.type.includes('application/vnd.openxmlformats-officedocument.wordprocessingml.document')))) {
                      setAlertFileTranscript(false);
                    } else {
                      setAlertFileTranscript(true);
                    }
                  }}
                />
              </div>
              {alertTranscript && (
                <span style={{ color: 'red' }}><RiErrorWarningLine /> Please setup file pdf / word / ppt</span>
              )}
            </div>
            {loading && (
              <Col md={12} lg={12}>
                <Progress animated value={progress}>{progress}%</Progress>
              </Col>
            )}
            <ButtonToolbar className="form__button-toolbar">
              <Button
                color="primary"
                type="submit"
                disabled={alertModul || alertVideo}
              >
                Save
              </Button>
            </ButtonToolbar>
          </form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default reduxForm({
  form: 'create_material', // a unique identifier for this form
})(CreateMaterialForm);
